import { useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { HiOutlineChevronDown, HiOutlineLocationMarker } from 'react-icons/hi';
import { MdCheckBoxOutlineBlank, MdOutlineMyLocation } from 'react-icons/md';
import { isObject } from 'lodash';
import { useCustOrgLocationArea } from '../../store/CustOrgLocationAreaStore';
import { AppDefaults, constants } from '../../helpers';
import './CameraWallDevices.scss';
import { camera, icontick, ActiveCheckBox } from '../../assets/images';
import { ReactComponent as LocationIcon } from '../../assets/images/icons/LocationIcon.svg';
import { ReactComponent as AllAreas } from '../../assets/images/icons/AllAreas.svg';
import { useDispatch } from 'react-redux';
import {
  setFiltersChanged,
  getFiltersChanged,
} from '../../store/reducers/DevicesReducer';
import { Checkbox } from '@mui/material';
import { IoCheckbox } from 'react-icons/io5';
import { cameraWallEnum } from '../../helpers/enums';

const LocationAreaSelector = ({ locations }) => {
  const [selectedOptions, setSelectedOptions] = useState([
    cameraWallEnum.online_sm,
    cameraWallEnum.offline_sm,
  ]);
  const [filterText, setFilterText] = useState(constants.DEVICE_FILTER_BY);
  const [locationAreas, setLocationAreas] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(
    constants.LOCATION_DROPDOWN_ALL_LOCATIONS_LABEL,
  );
  const [selectedArea, setSelectedArea] = useState(
    constants.LOCATION_DROPDOWN_ALL_AREAS_LABEL,
  );
  const {
    getDeviceWallSelectedLocation,
    setDeviceWallSelectedLocation,
    getDeviceWallSelectedArea,
    setDeviceWallSelectedArea,
    setDeviceWallSelectedDeviceStatus,
    getDeviceWallSelectedDeviceStatus,
  } = useCustOrgLocationArea();
  const selectedLocationData = getDeviceWallSelectedLocation();
  const selectedAreaData = getDeviceWallSelectedArea();
  const dispatch = useDispatch();
  const selectedDeviceConnectionStatus = getDeviceWallSelectedDeviceStatus();

  useEffect(() => {
    if (selectedDeviceConnectionStatus) {
      if (selectedDeviceConnectionStatus?.length === 0) {
        setDeviceWallSelectedDeviceStatus([cameraWallEnum.all_sm]);
        setFilterText(cameraWallEnum.all_cap);
      } else if (
        selectedDeviceConnectionStatus?.includes(cameraWallEnum.all_sm)
      ) {
        setSelectedOptions([
          cameraWallEnum.online_sm,
          cameraWallEnum.offline_sm,
        ]);
        setFilterText(cameraWallEnum.all_cap);
      } else {
        setSelectedOptions(selectedDeviceConnectionStatus);
        if (
          selectedDeviceConnectionStatus?.includes(cameraWallEnum.online_sm)
        ) {
          setFilterText(cameraWallEnum.online_cap);
        } else {
          setFilterText(cameraWallEnum.offline_cap);
        }
      }
    }
  }, [selectedDeviceConnectionStatus]);
  useEffect(() => {
    if (isObject(selectedLocationData) && selectedLocationData?.locationName) {
      setSelectedLocation(selectedLocationData?.locationName);
    }
    filterAreasByLocation(
      selectedLocationData?.locationId
        ? selectedLocationData?.locationId
        : AppDefaults.ALL_LOCATIONS_ID,
    );
    if (isObject(selectedAreaData) && selectedAreaData?.areaName) {
      setSelectedArea(selectedAreaData?.areaName);
    }
  }, [locations]);

  const filterAreasByLocation = (locationId) => {
    if (!locationId) return;
    if (locationId !== AppDefaults.ALL_LOCATIONS_ID) {
      const locationData = getLocationData(locationId);
      setSelectedLocation(locationData?.locationName);
      setLocationAreas(locationData?.areas);
      setDeviceWallSelectedLocation(locationData);
    } else {
      let areaList = [];
      locations?.forEach((location) => {
        areaList = [...areaList, ...location?.areas];
      });
      setLocationAreas(areaList);
      setSelectedLocation(constants.LOCATION_DROPDOWN_ALL_LOCATIONS_LABEL);
      setDeviceWallSelectedLocation({
        locationId: AppDefaults.ALL_LOCATIONS_ID,
      });
    }
  };

  const onSelectLocationHandler = (evtKey) => {
    if (!evtKey) return;
    if (evtKey == selectedLocationData.locationId) return;
    filterAreasByLocation(evtKey);
    dispatch(setFiltersChanged(true));
    setSelectedArea(constants.LOCATION_DROPDOWN_ALL_AREAS_LABEL);
    setDeviceWallSelectedArea({
      areaId: constants.LOCATION_DROPDOWN_ALL_AREAS_ID,
    });
  };

  const onSelectAreaHandler = (evtKey) => {
    if (!evtKey) return;
    if (evtKey == selectedAreaData.areaId) return;
    dispatch(setFiltersChanged(true));
    if (evtKey !== constants.LOCATION_DROPDOWN_ALL_AREAS_ID) {
      let selectedArea = locationAreas.find((area) => area.areaId === evtKey);
      setSelectedArea(selectedArea.areaName);
      setDeviceWallSelectedArea(selectedArea);
    } else {
      setSelectedArea(constants.LOCATION_DROPDOWN_ALL_AREAS_LABEL);
      setDeviceWallSelectedArea({
        areaId: constants.LOCATION_DROPDOWN_ALL_AREAS_ID,
      });
    }
  };

  const getLocationData = (locationId) => {
    if (!locationId) return;

    if (locationId === AppDefaults.ALL_LOCATIONS_ID) {
      return constants.LOCATION_DROPDOWN_ALL_LOCATIONS_LABEL;
    }
    return locations.find((location) => location.locationId === locationId);
  };

  const locationDropdownContent =
    locations?.length > 0 ? (
      locations?.map((location) => (
        <Dropdown.Item
          key={`location-${location.locationId}`}
          className={
            `area-selector-menu-item` +
            (selectedLocation === location.locationName ? ' active' : '')
          }
          eventKey={location.locationId}
        >
          {location.locationName}
        </Dropdown.Item>
      ))
    ) : (
      <Dropdown.Item
        key={`location-${0}`}
        className={`area-selector-menu-item`}
        eventKey={undefined}
      >
        {constants.LOCATION_DROPDOWN_NO_LOCATION_DATA_TEXT}
      </Dropdown.Item>
    );

  const areaDropdownContent =
    locationAreas?.length > 0 ? (
      locationAreas?.map((area) => (
        <Dropdown.Item
          key={`area-${area.areaId}`}
          className={
            `area-selector-menu-item` +
            (selectedArea === area.areaName ? ' active' : '')
          }
          eventKey={area.areaId}
        >
          {area.areaName}
        </Dropdown.Item>
      ))
    ) : (
      <Dropdown.Item
        key={`area-${0}`}
        className={`area-selector-menu-item`}
        eventKey={undefined}
      >
        {constants.LOCATION_DROPDOWN_NO_AREA_DATA_TEXT}
      </Dropdown.Item>
    );

  const handleCheckboxChange = (id) => {
    const intValue = selectedOptions;

    let updatedOptions;
    if (intValue.includes(id)) {
      if (intValue.length === 1) {
        return;
      }
      updatedOptions = intValue.filter((item) => item !== id);
    } else {
      updatedOptions = [...intValue, id];
    }

    let status;
    if (
      updatedOptions.includes(cameraWallEnum.online_sm) &&
      updatedOptions.includes(cameraWallEnum.offline_sm)
    ) {
      status = [cameraWallEnum.all_sm];
    } else {
      status = updatedOptions;
    }
    setSelectedOptions(updatedOptions);
    dispatch(setFiltersChanged(true));
    setDeviceWallSelectedDeviceStatus(status);
  };

  return (
    <div className="selection-wrapper">
      <Dropdown
        className="area-selector mr-3"
        onSelect={onSelectLocationHandler}
      >
        <Dropdown.Toggle
          variant="outline-secondary"
          id="dropdown-location"
          className="area-selector-toggle"
        >
          <div className="area-selected-wrapper">
            <LocationIcon
              className="dropdownIcons"
              stroke={getComputedStyle(
                document.documentElement,
              ).getPropertyValue('--hGreyscale_84')}
            />
            <span className="area-selected-name">{selectedLocation}</span>
          </div>
          <HiOutlineChevronDown
            size={20}
            stroke={getComputedStyle(document.documentElement).getPropertyValue(
              '--hGreyscale_84',
            )}
          />
        </Dropdown.Toggle>
        <Dropdown.Menu className="area-selector-menu">
          <Dropdown.Item
            className={
              `area-selector-menu-item` +
              (!selectedLocation ||
              selectedLocation ===
                constants.LOCATION_DROPDOWN_ALL_LOCATIONS_LABEL ||
              selectedLocation === AppDefaults.ALL_LOCATIONS_ID
                ? ' active'
                : '')
            }
            eventKey={AppDefaults.ALL_LOCATIONS_ID}
          >
            {constants.LOCATION_DROPDOWN_ALL_LOCATIONS_LABEL}
          </Dropdown.Item>
          {locationDropdownContent}
        </Dropdown.Menu>
      </Dropdown>
      <Dropdown className="area-selector" onSelect={onSelectAreaHandler}>
        <Dropdown.Toggle
          variant="outline-secondary"
          id="dropdown-area"
          className="area-selector-toggle"
        >
          <div className="area-selected-wrapper">
            <AllAreas className="dropdownIcons" />
            <span className="area-selected-name">{selectedArea}</span>
          </div>
          <HiOutlineChevronDown
            size={20}
            stroke={getComputedStyle(document.documentElement).getPropertyValue(
              '--hGreyscale_84',
            )}
          />
        </Dropdown.Toggle>
        <Dropdown.Menu className="area-selector-menu">
          <Dropdown.Item
            className={
              `area-selector-menu-item` +
              (!selectedLocation ||
              selectedLocation ===
                constants.LOCATION_DROPDOWN_ALL_AREAS_LABEL ||
              selectedLocation === constants.LOCATION_DROPDOWN_ALL_AREAS_ID
                ? ' active'
                : '')
            }
            eventKey={constants.LOCATION_DROPDOWN_ALL_AREAS_ID}
          >
            {constants.LOCATION_DROPDOWN_ALL_AREAS_LABEL}
          </Dropdown.Item>
          {areaDropdownContent}
        </Dropdown.Menu>
      </Dropdown>
      <Dropdown className="area-selector">
        <Dropdown.Toggle
          variant="outline-secondary"
          id="dropdown-area"
          className="area-selector-toggle"
        >
          <div className="area-selected-wrapper">
            <span className="area-selected-name">{filterText}</span>
          </div>
          <HiOutlineChevronDown
            size={20}
            stroke={getComputedStyle(document.documentElement).getPropertyValue(
              '--hGreyscale_84',
            )}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu className="area-selector-menu">
          {cameraWallEnum.cameraFilter?.map((filter) => (
            <Dropdown.Item
              key={`filter-${filter.Id}`}
              className={`area-selector-menu-item`}
              eventKey={filter.Id}
              onClick={() => handleCheckboxChange(filter.Id)}
            >
              <div className="text-filter padding-item text-color-dark-mode-menu">
                {selectedOptions.includes(filter.Id) ? (
                  // <div className="isChecked">
                  <img
                    className="icon-image isChecked p-0"
                    alt="tick-icon"
                    src={ActiveCheckBox}
                  />
                ) : (
                  // </div>
                  <div className="isUnChecked" />
                )}
                {filter.name}
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LocationAreaSelector;
